const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AdminReviewService = {
  async fetchReviews(filter = 'all') {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/reviews/?filter=${filter}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async fetchReviewById(reviewId) {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/reviews/${reviewId}/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async createReview(reviewData) {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/reviews/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reviewData),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create review');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async updateReview(reviewId, reviewData) {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/reviews/${reviewId}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reviewData),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to update review');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async deleteReview(reviewId) {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/reviews/${reviewId}/`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to delete review');
      }
      return true;
    } catch (error) {
      throw error;
    }
  },

  async approveReview(reviewId) {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/reviews/approve/${reviewId}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to approve review');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async rejectReview(reviewId) {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/reviews/reject/${reviewId}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to reject review');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async fetchReviewStatistics() {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/reviews-statistics/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },
};

export default AdminReviewService; 